<app-banner type="success" class="delete-user-banner">
    <p class="mat-body-1">
        Your account has been deleted successfully.
    </p>
    <br />
    <a mat-stroked-button href="https://rocketadmin.com/">Visit home page</a>
</app-banner>
